<template>
    <div class="relative">
        <input id="otp_input"
            type="tel"
            maxlength="6"
            v-model="otp" />

        <!-- <div class="grid grid-cols-6 gap-2 mb-2.5 px-1.5"> -->
        <div class="flex w-full text-center items-center justify-center">
            <label class="flex mx-1 bg-white border-8b9bbf border rounded-10 pb-14px w-45px h-50px text-tc-blue-1"
                for="otp_input"
                v-for="index in 6"
                :key="index">
                <div class="h-6 text-34 m-auto text-center">
                    {{getOtpDigit(index)}}
                </div>
            </label>
        </div>
    </div>
</template>
<script>
// helper
import RegxHelper from '@/helper/RegxHelper.js';
/**
 * Required Provider OtpProvider.
 */
export default {
    name: 'OtpInput',
    // inject: ['OtpProvider'],
    props: {
        // v-model
        // inputOtp: { type: String, required: true },
        inputValid: { type: Boolean, required: true }
    },
    watch: {
        otp: function (newVal) {
            let result = newVal;
            result = RegxHelper.removeNotNumber(result);

            this.otp = result;
            this.$emit('update:inputOtp', result);
            this.$emit('update:inputValid', (result.length == 6));

            // this.OtpProvider.methods.setOtp(result);
        }
    },
    data: function () {
        return {
            otp: ''
        };
    },
    methods: {
        getOtpDigit: function (index) {
            return this.otp.length >= index ? this.otp[index -1] : '';
        },
        resetOtp: function(){
            this.otp = '';
        }
    }
}
</script>
<style lang="scss" scoped>
#otp_input {
    position: absolute;
    top: 0;
    left: -50000%;
}
</style>
